import { render, staticRenderFns } from "./modifyPostcard.vue?vue&type=template&id=fe0722a8&scoped=true"
import script from "./modifyPostcard.vue?vue&type=script&lang=js"
export * from "./modifyPostcard.vue?vue&type=script&lang=js"
import style0 from "./modifyPostcard.vue?vue&type=style&index=0&id=fe0722a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0722a8",
  null
  
)

export default component.exports